
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from "react-bootstrap/Card";
import { Row, Col } from 'react-bootstrap';
import { BsFillFileTextFill } from "react-icons/bs";



function App() {
  return (
    <Row className="justify-content-md-center caardds" >
      <Card width= "100" className='caardds'
      // style={{ width: "20rem", marginTop: '10%' }}
      >
        <Card.Body >
          <Card style={{ marginTop: '1%' }}
            className='d-flex justify-content-center bg=#000'>
            <Card.Header>
              <h1 className='contents'>
                <BsFillFileTextFill  style={{color:"#90ee90"}}/>

                Privacy Policy 
              </h1>
            </Card.Header>
            <Card.Body>
              <h1>
                Terms and Condition
              </h1>
              <p>
                This Privacy Policy outlines the practices followed by [WhatsApp Status Saver] ("we," "us," or "our") with respect to the collection, use, and disclosure of personal information when you use our mobile application [WhatsApp Status Saver] ("the App").
              </p>
              <h3>
                Information We Collect
              </h3>
              <p>
                1	Personal Information: We do not collect any personal information from you while using the App. Personal information refers to any data that can be used to identify an individual, such as names, email addresses, phone numbers, or device information.<br></br>
                2	Non-Personal Information: We may collect certain non-personal information automatically when you use the App. This may include technical information about your device, such as your device model, and operating system version. This information is collected solely for the purpose of improving the App and providing a better user experience.

              </p>
              <h3>
                Use of Information
              </h3>
              <p>
                1 Usage Data: The non-personal information we collect may helps us understand how users interact with the App and allows us to make necessary optimizations.
              </p>
              <h3>
                Advertising
              </h3>
              <p>
                 Third-Party Advertisements: We may display third-party advertisements in the App. These advertisements are provided by external ad networks and may collect non-personal information about your device to deliver tailored ads. Please note that we do not have control over the information collected by these third-party advertisers.
              </p>
              <h3>
                Data Retention
              </h3>
              <p>
                1 Personal Information: As stated earlier, we do not collect any personal information. Therefore, we do not retain any personal information.<br></br>
                2 Non-Personal Information: We do not retain the non-personal information collected for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.

              </p>
              <h3>
                Third-Party Links
              </h3>
              <p>
                1 The App may contain links to third-party services. We are not responsible for the privacy practices or content of these third-party services. We encourage you to review the privacy policies of any third-party  services before providing any personal information or using their services.
              </p>
              <h3>
                Changes to the Privacy Policy
              </h3>
              <p>
                1 We reserve the right to update or modify this Privacy Policy from time to time. Any changes will be effective when we post the revised Privacy Policy in the App. We encourage you to review this Privacy Policy periodically to stay informed about how we collect, use, and protect your information.
              </p>
              <h3>
                Contact Us
              </h3>
              <p>
                1 If you have any questions or concerns about this Privacy Policy or our privacy practices, please contact us at [vegariusteam@gmail.com]
              </p>
              <Form>
                
                <input type="checkbox" id="agree" name="agree" value="agree" width="50px" height="50px" color='#90ee90' backgroundColor="#90ee90">
                </input>
               

                <label for="agree "> I agree with the Terms and Condition</label><br></br>

                <Row>
                  <Col lg={5} md={5} sm={5}></Col>
                  <Col lg={1} md={1} sm={1}>
                    <Button style={{backgroundColor:"#90ee90" , borderColor:"#90ee90"}}>
                      Accept
                    </Button>
                  </Col>
                  <Col lg={1} md={1} sm={1}>
                    <Button style={{backgroundColor:"#90ee90" , borderColor:"#90ee90"}}>
                      Reject
                    </Button>
                  </Col>
                  <Col lg={5} md={5} sm={5}>
                  </Col>
                </Row>


              </Form>
            </Card.Body>
          </Card>

        </Card.Body>
      </Card>
    </Row>
  );

}





export default App;
